import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import CallToAction from '../widgets/CallToAction';
import { Link } from "react-router-dom";
import { useContentfulEntry } from '../../hooks/useContentfulEntry';

function ImageAndText({ section, zIndex, imageLocation, headlineImage, key }) {

  const entry = section

  //  const { entries, loading, error } = useContentfulMultipleEntry(items);

  // const id = (entry && entry.fields && Array.isArray(entry.fields.items) && entry.fields.items.length > 0 && entry.fields.items[0] && entry.fields.items[0].sys && entry.fields.items[0].sys.id) ? entry.fields.items[0].sys.id : null;
  const id = entry.fields.items[0].sys.id
  const { entry: items, loading, error } = useContentfulEntry(id);

  if (loading || error || !entry || entry.length === 0) return null;

  const callToActionJustification = imageLocation === 'left' ? 'left' : 'right';
  const callToActionPaddingLeft = 0
  //  const entry = entries[0];
  let topEdgeTopStyle = {
    paddingTop: '1rem',
    backgroundColor: '#f3f1e6'
  };

  const imageClassName = imageLocation === 'left'
    ? "col-md-4 order-first"
    : "col-md-4 order-xs-first order-sm-first order-md-last";

  switch (entry.roughEdgeTop) {
    case 'Off White Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Lime Green Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Off White':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    case 'Lime Green':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      };
      break;
    default:
  }

  // console.log('item', item, item.items[0].fields)
  const item = items && items.items && items.items[0] ? items.items[0] : null;

  if (!item) return null;

  let callToAction = item.fields.displayCallToAction ?? false;
  let url = false;
  if (callToAction && item.fields.callToActionArticle) {
    url = item.fields.callToActionArticle.fields && item.fields.callToActionArticle.fields.url ? item.fields.callToActionArticle.fields.url : false;
    if (url && item.fields.callToActionArticle.fields.type === 'Blog Post') {
      url = 'blog/' + url;
    }
    if (url && item.fields.callToActionArticle.fields.type === 'Event') {
      url = 'events/' + url;
    }
  }
  const imageSource = item.fields.image && item.fields.image.fields.file
    ? item.fields.image.fields.file.url
    : headlineImage;


  return (
    <Container id="image-and-text" fluid style={topEdgeTopStyle}>
      <div className="card mb-3 item-left-hand-image">
        <div className="row g-1">
          <div className="col-md-8">
            <h3><Link style={{ textDecoration: 'none' }} to={url}>{entry.fields.headline}</Link></h3>
            <p className='tagline'>{entry.fields.tagline}</p>
            <Card.Body style={{ textOverflow: 'ellipsis', overflow: 'hidden', maxHeight: '6rem', width: '100%' }}>
              {item.fields.body}
            </Card.Body>
            <Card.Footer>
              {callToAction &&
                <div className='call-to-action' style={{ display: 'flex', justifyContent: callToActionJustification, paddingLeft: callToActionPaddingLeft }}>
                  <CallToAction
                    internalLink={url}
                    externalLink={item.fields.callToActionUrl}
                  >
                    <span className="fa-stack fa-2x" style={{ verticalAlign: 'center', marginBottom: '-1rem', alignContent: 'left' }}>
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fas fa-arrow-right fa-stack-1x fa-inverse"></i>
                    </span>
                    {item.fields.callToAction}
                  </CallToAction>
                </div>
              }
            </Card.Footer>
          </div>
          <div className={imageClassName}>
            {imageSource &&
              <img
                src={imageSource}
                alt={entry.fields.altText}
                style={{ width: '100%', objectFit: 'cover', objectPosition: 'center', minHeight: '100%' }}
              />
            }
          </div>
        </div>
      </div>
    </Container>
  );
}

export default ImageAndText;
